import { Grid } from '@mui/material';
import type { ResourceGroup } from '@/data/learning-path/interfaces';
import { ResourceItem } from '@/packages/learning-path/components/resource-item';

export const ResourceGroups = ({
  resourceGroup,
}: {
  resourceGroup: ResourceGroup[];
}) => {
  return (
    <Grid container spacing={2}>
      {resourceGroup.map((resource) => {
        const key =
          'course' in resource
            ? `course-${resource.course?.id}`
            : `link-${resource.external_link.id}`;

        return (
          <Grid size={{ xs: 12, sm: 6, md: 4 }} key={key}>
            <ResourceItem key={key} resource={resource} />
          </Grid>
        );
      })}
    </Grid>
  );
};
